(function () {
    'use strict';

    angular.module('wamasysApp').controller('MobileMessageController', MobileMessageController);

    MobileMessageController.$inject = ['$scope', '$interval', '$state', '$stateParams', 'MobileMessage', 'ParseLinks',
        'AlertService', 'pagingParams', 'paginationConstants', 'Principal', 'NotificationProtocol'];

    function MobileMessageController($scope, $interval, $state, $stateParams, MobileMessage, ParseLinks,
            AlertService, pagingParams, paginationConstants, Principal, NotificationProtocol) {
        var vm = this;
        vm.messages = [];
        vm.page = pagingParams.page;
        vm.users = [];
        vm.selected = {};
        vm.form = {type: 'VISIBLE', userIds: []};
        vm.canEdit = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT']);
        vm.load = load;
        vm.loadPage = loadPage;
        vm.openCreate = openCreate;
        vm.cancelCreate = function () { vm.creating = false; };
        vm.toggleAll = toggleAll;
        vm.filtersChanged = filtersChanged;
        vm.loadUsers = loadUsers;
        vm.chooseMatching = chooseMatching;
        vm.selectedCount = selectedCount;
        vm.send = send;
        vm.showDetails = showDetails;
        vm.loadRecipients = loadRecipients;
        vm.deliveryLabel = deliveryLabel;
        vm.permissionLabel = permissionLabel;
        vm.statusLabel = statusLabel;
        var usersGeneration = 0, viewGeneration = 0, eligible = {}, matchingSelection = null;
        $scope.$watch(function () {
            var account = Principal.getIdentityIfExist();
            return account ? [account.id || account.login, account.entiteParente && account.entiteParente.id,
                account.agence && account.agence.id].join(':') : '';
        }, function (next, previous) {
            if (next === previous) { return; }
            viewGeneration++; usersGeneration++;
            vm.creating = false; vm.detail = null; vm.recipients = []; vm.messages = []; vm.users = [];
            vm.selected = {}; eligible = {}; matchingSelection = null; vm.allMatching = false;
            vm.canEdit = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT']);
            if (next) { load(); }
        });

        load();
        var refreshPromise = $interval(refreshTracking, 2000);
        $scope.$on('$destroy', function () { viewGeneration++; usersGeneration++; $interval.cancel(refreshPromise); });

        function load() {
            var generation = viewGeneration;
            MobileMessage.query({page: pagingParams.page - 1, size: paginationConstants.itemsPerPage, sort: 'sentDate,desc'},
                function (data, headers) {
                    if (generation !== viewGeneration) { return; }
                    vm.messages = data;
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.page = pagingParams.page;
                }, error);
            MobileMessage.diagnostics({}, function (data) { if (generation === viewGeneration) { vm.diagnostics = data; } }, error);
        }

        function loadPage(page) { $state.go('.', {page: page, sort: 'sentDate,desc'}); }

        function refreshTracking() {
            if (!Principal.isAuthenticated()) { return; }
            var generation = viewGeneration;
            MobileMessage.query({page: vm.page - 1, size: paginationConstants.itemsPerPage, sort: 'sentDate,desc'},
                function (data, headers) {
                    if (generation !== viewGeneration) { return; }
                    vm.messages = data;
                    vm.totalItems = headers('X-Total-Count');
                });
            if (vm.detail) {
                loadRecipients();
            }
        }

        function openCreate() {
            vm.creating = true;
            vm.selected = {};
            vm.form = {type: 'VISIBLE', title: null, body: null, internalComment: null, userIds: []};
            vm.userQuery = ''; vm.collectorChoice = 'all'; vm.userPage = 1;
            vm.allMatching = false; vm.selectAll = false; matchingSelection = null; eligible = {};
            loadUsers();
        }

        function collectorOnly() { return vm.collectorChoice === 'all' ? null : vm.collectorChoice === 'yes'; }
        function fingerprint() { return NotificationProtocol.selectionFingerprint(vm.userQuery, collectorOnly()); }
        function filtersChanged() {
            // Une sélection globale ne doit jamais suivre silencieusement de nouveaux filtres.
            vm.selected = {}; eligible = {}; matchingSelection = null;
            vm.allMatching = false; vm.selectAll = false; vm.userPage = 1;
            loadUsers();
        }
        function loadUsers() {
            var generation = ++usersGeneration;
            vm.loadingUsers = true; vm.selectAll = false;
            MobileMessage.users({query: (vm.userQuery || '').trim(), collectorOnly: collectorOnly(),
                page: (vm.userPage || 1) - 1, size: 50}, function (data, headers) {
                if (generation !== usersGeneration || !vm.creating) { return; }
                vm.users = data; vm.totalUsers = parseInt(headers('X-Total-Count'), 10) || 0;
                angular.forEach(data, function (user) { if (user.accountActivated) { eligible[user.id] = true; } });
                vm.loadingUsers = false;
            }, function (response) { if (generation === usersGeneration) { vm.loadingUsers = false; error(response); } });
        }
        function chooseMatching() {
            vm.selected = {}; vm.selectAll = false;
            matchingSelection = vm.allMatching ? {fingerprint: fingerprint(), query: (vm.userQuery || '').trim(),
                collectorOnly: collectorOnly(), count: vm.totalUsers} : null;
        }
        function selectedCount() {
            if (vm.allMatching && matchingSelection) { return matchingSelection.count; }
            return Object.keys(vm.selected).filter(function (id) { return vm.selected[id] && eligible[id]; }).length;
        }

        function toggleAll() {
            angular.forEach(vm.users, function (user) {
                vm.selected[user.id] = vm.selectAll && user.accountActivated;
            });
        }

        function send() {
            if (vm.saving || vm.loadingUsers) { return; }
            var payload = angular.copy(vm.form);
            payload.userIds = [];
            angular.forEach(vm.selected, function (value, key) {
                if (value) {
                    if (eligible[key]) {
                        payload.userIds.push(parseInt(key, 10));
                    }
                }
            });
            if (vm.allMatching) {
                if (!matchingSelection || matchingSelection.fingerprint !== fingerprint()) {
                    AlertService.error('Les filtres ont changé. Vérifiez puis sélectionnez à nouveau les destinataires.'); return;
                }
                delete payload.userIds; payload.allMatching = true;
                payload.query = matchingSelection.query; payload.collectorOnly = matchingSelection.collectorOnly;
            }
            if (!selectedCount()) {
                AlertService.error('Sélectionnez au moins un utilisateur.');
                return;
            }
            if (payload.type === 'VISIBLE' && (!(payload.title || '').trim() || !(payload.body || '').trim())) {
                AlertService.error('Renseignez le titre et le message.'); return;
            }
            if (vm.allMatching && !window.confirm('Envoyer ce message à ' + selectedCount() + ' utilisateurs correspondant aux filtres affichés ?')) { return; }
            if (vm.form.type === 'UPLOAD_LOGS_AND_ARCHIVES' &&
                    !window.confirm('Cette commande déclenchera silencieusement l’envoi des journaux et archives des appareils sélectionnés. Continuer ?')) {
                return;
            }
            vm.saving = true;
            var generation = viewGeneration;
            MobileMessage.create(payload, function () {
                if (generation !== viewGeneration) { return; }
                vm.saving = false;
                vm.creating = false;
                load();
                AlertService.success('Message envoyé aux destinataires sélectionnés.');
            }, function (response) {
                if (generation !== viewGeneration) { return; }
                vm.saving = false;
                error(response);
            });
        }

        function showDetails(message) {
            vm.detail = message;
            vm.recipientPage = 1; vm.recipients = [];
            loadRecipients();
        }
        function loadRecipients() {
            if (!vm.detail) { return; }
            var message = vm.detail, page = vm.recipientPage || 1;
            var generation = viewGeneration;
            MobileMessage.recipients({id: message.id, page: page - 1, size: 50, sort: 'id,asc'},
                function (data, headers) {
                    if (generation === viewGeneration && vm.detail === message && page === vm.recipientPage) {
                        vm.recipients = data; vm.recipientTotal = parseInt(headers('X-Total-Count'), 10) || 0;
                    }
                }, error);
        }

        function deliveryLabel(user) {
            if (!user || user.deliveryMode === 'NO_DEVICE') { return 'Boîte Web ; aucun appareil Android enregistré'; }
            if (user.deliveryMode === 'FCM') { return 'Firebase (' + user.firebaseDeviceCount + ')'; }
            return 'Repli HTTP';
        }

        function permissionLabel(permission) {
            if (permission === true) { return 'Autorisées'; }
            if (permission === false) { return 'Refusées'; }
            return 'Inconnues';
        }

        function statusLabel(recipient) {
            var status = angular.isObject(recipient) ? recipient.status : recipient;
            if (status === 'NO_DEVICE' && vm.detail && vm.detail.type !== 'VISIBLE') { return 'Aucun appareil Android enregistré'; }
            if (status === 'PENDING' && angular.isObject(recipient)) {
                if (recipient.errorMessage) { return 'Échec Firebase, nouvelle tentative prévue'; }
                if (!vm.diagnostics || !vm.diagnostics.initialized ||
                        recipient.userDiagnostics.deliveryMode !== 'FCM') {
                    return 'Disponible dans la boîte, en attente de récupération';
                }
                return 'En attente du traitement serveur';
            }
            var labels = {
                PENDING: 'En attente d’envoi',
                NO_DEVICE: 'Disponible dans la boîte — aucun appareil Android',
                ACCEPTED_BY_FIREBASE: 'Notification Android acceptée par Firebase',
                RECEIVED: 'Reçu par l’application',
                READ: 'Lu par l’utilisateur',
                COMMAND_STARTED: 'Commande démarrée',
                COMMAND_COMPLETED: 'Commande terminée',
                COMMAND_FAILED: 'Commande en erreur',
                FAILED: 'Échec de l’envoi'
            };
            return labels[status] || status;
        }

        function error(response) {
            AlertService.error(response && response.data && response.data.message ? response.data.message :
                'Erreur lors de l’opération sur les messages mobiles.');
        }
    }
})();
